import _each from 'lodash/each'

function initCheckoutAddressPagination(element) {
    const paginationContainer = element || $('.pagination-js-container');
    if (paginationContainer.length > 0) {
        if (paginationContainer.data('paginate')) {
            paginationContainer.data('paginate').destroy();
        }
        const options = {
            scope: $('.pagination-item:not(.pagination-item-ignore)')
        };
        paginationContainer.paginate(options);
    }
}

function search(element) {
    const query = element.value, type = element.dataset.type, url = window.config.urls.addresses[type].filter,
        container = element.closest('.address-filter-container');

    const spinner = container.querySelector('.input-loading-spinner');
    if (spinner) {
        spinner.style.display = 'inline-block';
    }

    axios.post(url, {q: query}).then(({data}) => {

        const items = container.querySelectorAll('.address-item');

        _each(items, function (item) {
            if (data.results.includes(parseInt(item.dataset.filter))) {
                item.classList.remove('pagination-item-ignore');
                item.classList.remove('d-none');
            } else {
                item.classList.add('pagination-item-ignore');
                item.classList.add('d-none');
            }
        });

        initCheckoutAddressPagination($('.pagination-js-container', container));
    }).finally(() => {
        if (spinner) {
            spinner.style.display = 'none';
        }
        checkEmptySearchResults(container);
    });
}

function doneTyping(element, callback, timeout) {
    // Get the input box
    const inputs = document.getElementsByClassName(element);

    _each(inputs, function (input, key) {
        // Init a timeout variable to be used below
        let timeoutHandler = null;

        // Listen for keystroke events
        input.addEventListener('keyup', function (e) {
            // Clear the timeout if it has already been set.
            // This will prevent the previous task from executing
            // if it has been less than <MILLISECONDS>
            clearTimeout(timeoutHandler);

            // Make a new timeout set to go off in 1000ms (1 second)
            timeoutHandler = setTimeout(function () {
                callback(input);
            }, timeout || 500);
        });
    });
}

function checkEmptySearchResults(container) {
    const emptyItem = container.querySelector('.empty-address-item');
    if (emptyItem) {
        emptyItem.classList.add('d-none');
        if ($('.address-item:visible', container).length === 0) {
            emptyItem.classList.remove('d-none');
        }
    }
}

export default {initCheckoutAddressPagination, search, doneTyping}
